
/* ----- Middlewares ----- */
import pwaAuth from "@/middleware/pwa/pwaAuth";
import pwaGuest from "@/middleware/pwa/pwaGuest";

/* ----- Routes ----- */
import progressiveWebAppRoutes from "@/router/routes/pwa-routes";

/* ----- Layout ----- */
import ProgressiveWebAppAuth from "@/pages/ProgressiveWebApp/Auth/ProgressiveWebAppAuth";
import ProgressiveWebAppLayout from "@/pages/ProgressiveWebApp/ProgressiveWebAppLayout";

/* ----- Views ----- */
import ProgressiveWebAppLogin from "@/pages/ProgressiveWebApp/Auth/ProgressiveWebAppLogin";

/* ----- ----- ----- ----- ----- ----- ----- */

const progressiveWebAppPublicRoutes = [
    {
        path: "login",
        name: "pwaLogin",
        component: ProgressiveWebAppLogin,
        meta: {}
    },
].map(route => {
    return {...route, meta: { ...route.meta, middleware: pwaGuest }}
})

const progressiveWebAppAuthRoutes = [
    ...progressiveWebAppRoutes
].map(route => {
    return {...route, meta: { ...route.meta, middleware: pwaAuth }}
})

const routes = [
    {
        path: "/pwa",
        redirect: "/pwa/dashboard",
    },
    {
        path: '/pwa',
        component: ProgressiveWebAppAuth,
        meta: { middleware: pwaGuest },
        children: progressiveWebAppPublicRoutes
    },
    {
        path: '/pwa',
        component: ProgressiveWebAppLayout,
        meta: { middleware: pwaAuth },
        children: progressiveWebAppAuthRoutes
    },
]
export default routes